import React from "react";
import { Link } from "react-router-dom";

export default function Allegations(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Responding to allegations or suspicions about suspected poor practice
        and/or child abuse
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            It is the responsibility of everyone working in Slum Soccer/ Krida
            Vikas Sanstha to report any concerns regarding child abuse to the
            Child Protection Officer. However deciding or judging the merits of
            the concern may be avoided.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Slum Soccer/ Krida Vikas Sanstha shall fully support and protect
            anyone who, in good faith, reports his or her concern regarding poor
            practice or regarding a child being abused.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            On receipt of any complaint/ report regarding suspicion or incident
            that child safety has been compromised or a child has been abused by
            a member of SS staff or associate, the CPO shall
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Bring the matter to attention of CEO immediately. On receipt of
                concern/ complaint against any SS staff or associate regarding
                child safety or abuse, CEO shall issue instructions to the staff
                member/ associate to stop attending their workplace/ SS office
                pending CSPG inquiry. If, after CSPG inquiry, the
                concern/complaint is found to be without base/ unsubstantiated,
                CEO shall revoke/ withdraw such instructions and ask the
                individual to resume attending to their duties. In such an
                event, their absence from workplace shall be treated as on duty.
                Further, SS/KVS will take appropriate steps to minimize damage
                to the reputation of the individual concerned.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Convene and lead the CSPG in holding an internal inquiry. The
                inquiry by CSPG may include interviewing all parties involved
                (including witnesses) to gather all relevant details and
                evidences of the allegation. Within 15 working days of receiving
                the report, the CPO shall submit the findings and
                recommendations of CSPG to CEO, Slum Soccer/ Krida Vikas Sanstha
                for taking further action in the matter.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                take steps considered necessary by him/her to ensure the safety
                of the child in question and any other child who may be at risk.
                The parents or carers of the child will be contacted as soon as
                possible.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Response to poor practices
          </h2>
          <span className="text-gray-700 block mb-1">
            If the complaint/ report regarding suspicion or incident is found to
            be a case of poor practice by any Slum Soccer staff, the CEO, Slum
            Soccer shall take appropriate disciplinary action in a fair and
            transparent manner. He shall also institute steps for corrective and
            precautionary measure to prevent recurrence of the incident.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Response to suspected abuse
          </h2>
          <span className="text-gray-700 block mb-1">
            If the complaint/ report regarding suspicion or incident appears to
            be a case of child abuse, Slum Soccer/ Krida Vikas Sanstha CEO shall
            refer the allegation to the district Child Welfare Committee without
            any delay. The CEO, SS may also seek the advice of CWC on further
            course of action required to be taken by Slum Soccer regarding the
            alleged abuser, the abused child and the parents of the abused
            child.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Allegations of previous abuse
          </h2>
          <span className="text-gray-700 block mb-1">
            Allegations of abuse may be made some time after the event (e.g. by
            an adult who was abused as a child or by a member of staff who is
            still currently working with children). Where such an allegation is
            made, the organization should follow the procedures as detailed
            above. This is because other children, either within or outside the
            organization’s purview, may be at risk from this person. Anyone who
            has a previous criminal conviction for offences related to child
            abuse is to be automatically excluded from working with children.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-4">
            At all stages of the response process the welfare of the child
            should remain of paramount importance throughout.
          </span>
          <span className="text-gray-700 block mb-1">
            The reporting and response process is depicted in form of a flow
            chart at{" "}
            <Link
              to="/csppolicy/annexure6"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="text-yellow-500 hover:underline"
            >
              Annexure-6
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
}
